<template>
  <div class="layout">
    <Navbar class="layout__topo"/>
    <main class="layout__corpo">
      <slot/>
    </main>
    <aside class="layout__lateral" :class="{ 'layout__lateral__ativada' : barraHabilitada }">
      <div class="clickbtn" @click="controleBarraLateralMethod">
        <v-icon scale="2.5" name="arrow-right" class="clickbtn__icon"/>
      </div>
      <BarraLateral @clicouItemMenu="clicouItemMenuMethod"/>
    </aside>
  </div>
</template>

<script>
import BarraLateral from '../barra-lateral/BarraLateral.vue'
import Navbar from '../navbar/Navbar.vue'

export default {
  name: 'LayoutBarraLateral',
  data() {
    return {
      barraHabilitada: true,
      windowWidth: window.innerWidth,
    }
  },
  mounted() {
    this.$nextTick(() => {
      window.addEventListener('resize', () => {
        this.windowWidth = window.innerWidth
      })
    })
  },
  watch: {
    windowWidth(newWidth) {
      if (!this.ehVersaoMobile(newWidth)) {
        this.barraHabilitada = true
      }
    },
  },
  components: {
    BarraLateral,
    Navbar,
  },
  methods: {
    controleBarraLateralMethod() {
      this.barraHabilitada = !this.barraHabilitada
    },
    clicouItemMenuMethod() {
      if (this.ehVersaoMobile(this.windowWidth)) {
        this.barraHabilitada = false
      }
    },
    ehVersaoMobile(tamanho) {
      return tamanho <= 1200
    },
  },
}

</script>

<style lang="scss" scoped>
@import "@/scss/breakpoints.scss";
@import "@/scss/colors.scss";

.layout {
  height: inherit;
  min-width: 100%;

  display: flex;
  flex-direction: column;

  @media (min-width: $medium-size) {
    flex-direction: row;
  }

  &__topo {
    position: fixed;
  }

  &__lateral {
    position: fixed;
    top: 0;
    left: -245px;
    width: 245px;
    height: 100%;
    transition: 0.3s;
    z-index: 101;
    background-color: $cor-barralateral;

    @media (min-width: $extra-large-size) {
      left: -185px;
      width: 185px;
    }

    &__ativada {
      left: 0;
    }
  }

  &__corpo {
    margin-top: 6em;
    order: 3;
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 0.5em;

    @media (min-width: $medium-size) {
      align-items: center;
    }

    @media (min-width: $extra-large-size) {
      margin-left: 12em;
    }
  }
}

.clickbtn {
  &__icon {
    display: none;
  }
  @media (max-width: $extra-large-size) {
    position: absolute;
    width: 50px;
    background-color: #f2b545;
    height: 50px;
    top: 7px;
    right: -50px;
    border: none;
    cursor: pointer;
    outline: none;
    border-top-right-radius: 10%;
    border-bottom-right-radius: 10%;
    content: "";

    &__icon {
      margin-top: 0.1em;
      margin-left: 0.15em;
      color: $cor-fonte-clara;
      display: inline;
    }
  }
}
</style>
